import { useState, useEffect } from "react";
import { CSVLink } from "react-csv";
import DraggableModal from "./DraggableModal";
import StyledButton from "./StyledButton";
import theme from "../../helpers/theme";

/**
 * generic CSV export modal that requires user confirmation before download
 * @param {Array.<Object>} data array of rows as JSON objects
 * @param {String} fileName unique text identifier for this export file
 * @param {String} downloadMessage modal popup message with ### to be replaced by number of rows to go into csv
 * @param {boolean} modalVisible make modal visible when true
 * @param {function} handleCancelModal modal closing function
 * @returns modal with button to trigger CSV download
 */
const CsvExportModal = (props) => {
  const [exportData, setExportData] = useState([]);

  const unknownValuesAsBlank = (value) => {
    if (typeof value === "string") {
      value.replace(/^(unknown)$/i, "");
    } else if (value === null) {
      value = "";
    }
    return value;
  };

  const formatColumnNames = (columns) => {
    let newCols = columns.map((col) => {
      let words = col
        .split("_")
        .map((word) => {
          return word[0].toUpperCase() + word.substring(1);
        })
        .join(" ");
      return words;
    });
    return newCols;
  };

  const formatFileName = (fileName) => {
    let date = new Date().toISOString().split("T")[0];
    let compressedDate = date.replace(/-/g, "");
    return `${fileName}-${compressedDate}.csv`;
  };

  const formatMessage = (message) => {
    // exportData.length-1 because the first array in exportData is column headers
    if (!exportData || exportData.length < 1) {
      return message;
    }
    let formattedMessage = message.replace("###", exportData.length - 1);
    return formattedMessage;
  };

  useEffect(() => {
    let dataArray = props.data;
    if (!dataArray || dataArray.length < 1) {
      return;
    }
    let columns = Object.keys(dataArray[0]);
    let newExportData = dataArray.map((account) => {
      let row = [];
      for (let i = 0; i < columns.length; i++) {
        row.push(unknownValuesAsBlank(account[columns[i]]));
      }
      return row;
    });
    newExportData.unshift(formatColumnNames(columns));
    setExportData(newExportData);
  }, [props.data]);

  return (
    <DraggableModal
      modalVisible={props.modalVisible}
      handleCancelModal={props.handleCancelModal}
      modalTitle="Export Data"
      content={
        props.downloadMessage
          ? formatMessage(props.downloadMessage)
          : "Confirm Download"
      }
      actions={
        <StyledButton
          width={"25%"}
          children={
            <CSVLink
              data={exportData}
              filename={formatFileName(props.fileName)}
              asyncOnClick={true}
              style={{ color: theme.palette.primary.lighter }}
            >
              Download
            </CSVLink>
          }
        />
      }
    />
  );
};

export default CsvExportModal;
